import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgElementHighlightVue = _resolveComponent("SvgElementHighlightVue")!

  return (_openBlock(), _createElementBlock("g", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contentStore.crtGroupId, (id, idx) => {
      return (_openBlock(), _createBlock(_component_SvgElementHighlightVue, {
        key: idx,
        element: _ctx.contentStore.getElement(id),
        onMousedown: _withModifiers(($event: any) => (
        _ctx.mouseDownOnSelected($event.shiftKey || $event.ctrlKey, id)
      ), ["stop"])
      }, null, 8, ["element", "onMousedown"]))
    }), 128))
  ]))
}